import React from 'react'
import Jahazi from '../../assets/digi.jpg'
import ViaLogo from '../../assets/infra.jpg'
import Fafoco from '../../assets/ops.jpg'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { FaIcons } from "react-icons/fa6";

const Pillars = () => {
    // Parent container variants to control the children
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.3, // Delay between each card's animation
            }
        }
    };

    // Individual card variants
    const cardVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: { 
            opacity: 1, 
            y: 0,
            transition: { duration: 2, ease: "easeOut" } 
        }
    };

    return (
        <section className="featured">
            <div className="overlay">
                <div className="container h">
                    <div className="space"></div>
                    <div className="space"></div>
                    
                    {/* The motion.div here controls the staggering of the cards inside it */}
                    <motion.div 
                        className="cards"
                        variants={containerVariants}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: false, amount: 0.1 }}
                    >
                        {/* Card 1 */}
                        <motion.div className="card" variants={cardVariants}>
                            <div className="wrapper">
                                <h3 className="card-head-primary">Technical Engineering & Infrastructure</h3>
                                <div className="card-image-container">
                                    <img src={ViaLogo} alt="Via Platform" className="card-image" />
                                    <div className="description">
                                        <p className="card-text-dark">
                                            I hold NITA Electrical Wiring Certificates (Grades I, II, & III) from Don Bosco. 
                                            Currently, I am an Electrician Intern at Jahazi Tech, specialising in residential 
                                            and commercial wiring systems. My background also includes two years at Plumbing 
                                            Solutions, where I mastered pipe installations and mechanical maintenance.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </motion.div>

                        {/* Card 2 */}
                        <motion.div className="card" variants={cardVariants}>
                            <div className="wrapper">
                                <h3 className="card-head-primary">Operational Foundation</h3>
                                <div className="card-image-container">
                                    <img src={Fafoco} alt="Amazing Food Company" className="card-image" />
                                    <div className="description">
                                        <p className="card-text-dark">
                                            My professional discipline was built through five years of service within the retail sector. 
                                            At Pick'n’Pay family Store Plumstead - Cape Town, I completed four years of combined full-time and part-time work. 
                                            During my year at Spar Group, I displayed strong dedication by successfully earning my GED 
                                            while managing high-volume inventory operations.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </motion.div>

                        {/* Card 5 */}
                        <motion.div className="card" variants={cardVariants}>
                            <div className="wrapper">
                                <h3 className="card-head-primary">Digital Architecture & Design</h3>
                                <div className="card-image-container">
                                    <img src={Jahazi} alt="Plumbing Solutions" className="card-image" />
                                    <div className="description">
                                        <p className="card-text-dark">
                                            I build clean, functional web layouts using HTML5, CSS3, and JavaScript. 
                                            My portfolio features a web project for Amazing Food Company and the development of the Via platform. 
                                            I also utilise Canva and Photoshop to craft professional visual narratives, ensuring a 
                                            high-quality and modern user experience.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    </motion.div>
                </div>
                <div className="space"></div>
                <div className="btns-2 m-2">
                    <button className="light btn">
                        <Link to='/portfolio'>
                            Full Portfolio {' '} <FaIcons className='setting'/>
                        </Link>
                    </button>
                </div>
            </div>
        </section>
    )
}

export default Pillars